export default __webpack_public_path__ + "static/myna-31ba8e389f343c575e83f2f2ad02c88f.png";